/**
 * Common validation patterns for form fields
 */

// Username validation - only alphanumeric characters (a-z, A-Z, 0-9)
export const REGEX_USERNAME = /^[a-zA-Z0-9]+$/;

// Email validation - standard email format
export const REGEX_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// Password validation - no spaces allowed
export const REGEX_PASSWORD = /^\S+$/;

// Name validation - letters, spaces, hyphens, and apostrophes
export const REGEX_NAME = /^[a-zA-Z\s'-]+$/;

// Phone number - numbers and common phone separators
export const REGEX_PHONE = /^[0-9+\-\s()]+$/;

// Numbers only
export const REGEX_NUMBERS = /^[0-9]+$/;

// Alphanumeric with spaces
export const REGEX_ALPHANUMERIC_WITH_SPACES = /^[a-zA-Z0-9\s]+$/;

/**
 * Validation messages for common fields
 */
export const ValidationMessages = {
  username: "Username can only contain letters and numbers (no spaces or special characters)",
  email: "Please enter a valid email address",
  password: "Password cannot contain spaces",
  name: "Name can only contain letters, spaces, hyphens and apostrophes",
  required: "This field is required",
};

/**
 * Helper function to prevent specific keys while typing
 * @param {Event} e - The keyboard event
 * @param {Array} keysToPrevent - Array of keys to prevent (e.g., [' '] to prevent spaces)
 */
export const preventKeys = (e, keysToPrevent) => {
  if (keysToPrevent.includes(e.key)) {
    e.preventDefault();
  }
};

/**
 * Helper function to create validation rules with patterns
 * @param {Object} options - Validation options
 * @returns {Object} - React Hook Form rules object
 */
export const createValidationRules = ({
  required = false,
  pattern = null,
  minLength = null,
  maxLength = null,
  validate = null,
  requiredMessage = ValidationMessages.required,
}) => {
  const rules = {};

  if (required) {
    rules.required = requiredMessage;
  }

  if (pattern) {
    rules.pattern = {
      value: pattern.value || pattern,
      message:
        pattern.message ||
        (pattern === REGEX_USERNAME
          ? ValidationMessages.username
          : pattern === REGEX_EMAIL
          ? ValidationMessages.email
          : pattern === REGEX_PASSWORD
          ? ValidationMessages.password
          : pattern === REGEX_NAME
          ? ValidationMessages.name
          : "Invalid format"),
    };
  }

  if (minLength) {
    rules.minLength = {
      value: minLength.value || minLength,
      message: minLength.message || `Minimum ${minLength.value || minLength} characters required`,
    };
  }

  if (maxLength) {
    rules.maxLength = {
      value: maxLength.value || maxLength,
      message: maxLength.message || `Maximum ${maxLength.value || maxLength} characters allowed`,
    };
  }

  if (validate) {
    rules.validate = validate;
  }

  return rules;
};
